
import { mapGetters } from 'vuex';
import KakaoHelper from '@/utils/KakaoHelper';
import common from '@/utils/common';
export default {
  name: 'PostComponent',
  mixins: [common],
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    category: {
      type: String,
      default: '',
    },
    categoryColor: {
      type: String,
      default: '#00B0E9',
    },
  },
  computed: {
    ...mapGetters(['getPostColors']),
    styleObject() {
      return {
        '--category-color': this.categoryColor,
      };
    },
  },
  watch: {
    'item.thumb_up': {
      handler() {
        this.upCount = this.item.thumb_up;
      },
      immediate: true,
    },
    'item.thumb_down': {
      handler() {
        this.downCount = this.item.thumb_down;
      },
      immediate: true,
    },
    'item.is_thumb': {
      handler() {
        if (this.item.is_thumb === 2) {
          this.thumbsUp = true;
          this.thumbsDown = false;
        } else if (this.item.is_thumb === 1) {
          this.thumbsDown = true;
          this.thumbsUp = false;
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      thumbsUp: false,
      thumbsDown: false,
      upCount: 0,
      downCount: 0,
    };
  },
  methods: {
    move(item) {
      if (this.category === '공 지') {
        this.$router.push(`/notices/${item.id}`);
      } else {
        this.$router.push({
          path: `/posts/${item.id}`,
          query: { category: this.category, categoryColor: this.categoryColor },
        });
      }
    },
    share() {
      let kakaoHelper = new KakaoHelper(Kakao);
      if (this.$auth.user) {
        kakaoHelper.sharePost(this.item, this.$auth.user?.id);
        // kakaoHelper.initSharePost(this.item, this.$auth.user?.id);
      } else {
        this.$router.push('/auth/login');
      }
    },
    toggleUp() {
      if (!this.$auth.user) {
        alert('로그인 후 이용해주세요.');
        return;
      }
      if (this.thumbsUp) {
        this.thumbsUp = false;
        this.upCount -= 1;
        this.handleThumbCount('0');
      } else {
        this.thumbsUp = true;
        this.upCount += 1;
        this.handleThumbCount('2');
      }
      if (this.thumbsDown) {
        this.thumbsDown = false;
        this.downCount -= 1;
      }
    },
    toggleDown() {
      if (!this.$auth.user) {
        alert('로그인 후 이용해주세요.');
        return;
      }
      if (this.thumbsDown) {
        this.thumbsDown = false;
        this.downCount -= 1;
        this.handleThumbCount('0');
      } else {
        this.thumbsDown = true;
        this.downCount += 1;
        this.handleThumbCount('1');
      }
      if (this.thumbsUp) {
        this.thumbsUp = false;
        this.upCount -= 1;
      }
    },
    async handleThumbCount(countType) {
      const response = await this.$axios.put(
        `/api/thumbs/posts/${countType}/${this.item.id}`
      );
    },
    //숫자를 아래 조건의 포맷으로 변경
    formatNumber(num) {
      if (num >= 0 && num < 10000) {
        // Format for numbers in the 0 - 9999 range
        if (num == 0 || num < 1000) return num;
        return (num / 1000).toFixed(1) + '천';
      } else if (num >= 10000 && num <= 99999999) {
        // Format for numbers in the 10000 - 99999999 range
        return (num / 10000).toFixed(1) + '만';
      } else {
        // Return the number as is if it doesn't fall in the above ranges
        return num?.toString();
      }
    },
  },
  mounted() {},
};
